const defaultState = {
  isOpen: false
};

// actions
const OPEN_VIDEO = 'videoPlayer/OPEN_VIDEO';
const CLOSE_VIDEO = 'videoPlayer/CLOSE_VIDEO';

// actions creators
export const openVideo = (url, title, isOpen = true) => {
  return {
    type: OPEN_VIDEO,
    payload: { url, title, isOpen }
  };
};

export const closeVideo = () => {
  return {
    type: CLOSE_VIDEO
  };
};

// reducers
function videoPlayer(state = defaultState, action) {
  switch (action.type) {
    case OPEN_VIDEO:
      return action.payload;
    case CLOSE_VIDEO:
      return { ...state, isOpen: false };
    default:
      return state;
  }
}

export default videoPlayer;



// WEBPACK FOOTER //
// ./src/redux/reducers/videoPlayer.js